import { FunctionComponent } from 'react';
import cn from 'classnames';
import styles from './Notification.module.css';
import {Dropdown, Image} from 'react-bootstrap';
import { ASSESTS } from '../../../../../constant/assest';
import CustomButton, { ButtonType } from '../../../CustomButton/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../../redux/store';
import { markNotificationAsRead, dismissNotification } from '../../../../../redux/slices/notification/actions';
import { Notification as NotificationType } from '../../../../../redux/slices/notification/types';
import { formatDistanceToNow } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { PageRoutes } from '../../../../../routing/paths';
import { getColorForUser } from '../../../UserCard/UserCard';
import LocalStorageService, { LocalStorageKeys } from '../../../../../services/localStorageService';
import { UserType } from '../../../../../constant/enums';

interface INotificationProps {
    className?: string;
}

const Notification: FunctionComponent<INotificationProps> = ({
    className,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { notifications, unreadCount, loading } = useSelector((state: RootState) => state.notifications);
    const user = LocalStorageService.get<{ role: string }>(LocalStorageKeys.USER);
    const isSuperAdmin = user?.role === UserType.SUPER_ADMIN;
    

    const handleAccept = (notification: NotificationType) => {    
        if (notification.requested_by_id && notification.requested_by?.full_name) {
          dispatch(markNotificationAsRead(notification.id));
          navigate(PageRoutes.RESETPASSWORD, {
            state: {
              userId: notification.requested_by_id,
              userName: notification.requested_by.full_name,
            },
          });
        }
      };

    const handleDismiss = (notificationId: number) => {
        dispatch(dismissNotification(notificationId));
    };
    
    const renderNotificationItem = (notification: NotificationType) => {
        const userImage = notification.requested_by?.profile_image;
        const userName = notification.requested_by?.full_name;
        const timeAgo = formatDistanceToNow(new Date(notification.created_at), { addSuffix: true });
        const bgColor = getColorForUser(userName || 'N/A');
        
        return (
            <Dropdown.Item key={notification.id} bsPrefix={styles.notificationItem} as={'div'} onClick={(e) => e.stopPropagation()}>
                <div className={styles.imageWrap}>
                    <div className={cn(styles.image, styles.circleImage, !userImage && styles.userAvatarText)}
                      style ={!userImage ? { backgroundColor: bgColor } : undefined}>
                        {userImage ? 
                        <Image src={userImage} alt={userName} width={48} height={48}/> : 
                        (userName ? userName.trim()?.charAt(0).toUpperCase() : '?')
                    }
                    </div>
                    <div title={userName} className={styles.userName}>{userName}</div>
                </div>
                <div className={styles.detailWrap}>
                    <div className={styles.query}>{notification.title}<span className={styles.queryTime}>{timeAgo}</span></div>
                    <div className={styles.querysummary}>{notification.message}</div>
                    <div className={styles.handlersOption}>
                        {!notification.is_read  && isSuperAdmin && (
                            <CustomButton
                                className={cn(styles.linkBtn, styles.greenBtn)}
                                onClick={() => handleAccept(notification)}
                            >
                                Accept
                            </CustomButton>
                            )}

                        <CustomButton
                            className={cn(styles.linkBtn, styles.dissmisBtn)}
                            onClick={() => handleDismiss(notification.id)}
                        >
                            Dismiss
                        </CustomButton>
                    </div>
                    <CustomButton
                        btnType={ButtonType.IMAGE}
                        className={styles.closeBtn}
                        onClick={() => handleDismiss(notification.id)}
                    >
                        <Image src={ASSESTS.CLOSE} alt='Close' width={20} height={20} />
                    </CustomButton>
                </div>
            </Dropdown.Item>
        );
    };

    return (
        <Dropdown className={cn(styles.notification, className)}>
            <Dropdown.Toggle variant="light" className={styles.notificationBtn}>
                {unreadCount > 0 && <span className={styles.notificationCount}>{unreadCount}</span>}
                <Image 
                    src={ASSESTS.BELL}
                    width={30}
                    height={30}
                    alt="Notification"
                />
            </Dropdown.Toggle>
            <Dropdown.Menu className={styles.notificationDopdown}>
                    {loading === 'pending' && <Dropdown.Item as="div" className={styles.centered}>Loading...</Dropdown.Item>}
                    {loading === 'succeeded' && notifications.length === 0 && <Dropdown.Item as="div" className={styles.centered}>No notifications found.</Dropdown.Item>}
                    {loading === 'succeeded' && notifications.map(renderNotificationItem)}
                    {loading === 'failed' && <Dropdown.Item as="div" className={styles.centered}>Error loading notifications.</Dropdown.Item>}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default Notification;
